import ClientBase from "../ClientBase";

class FramesClient extends ClientBase {
    async getFramesByScanId(scanId) {
        const data = await this.get(`api/v1/frames/scans/${scanId}`);
        return data ?? [];
    }

    // Equirectangular panorama blob paths for a scan (one per capture), e.g.
    // "assetId/scans/scanId/frames/equirect/frame_00001_equirect.webp".
    async getEquirectFramePaths(orgId, assetId, scanId) {
        const data = await this.get(
            `api/v1/frames/organizations/${orgId}/assets/${assetId}/scans/${scanId}/equirect`);
        return data ?? [];
    }
}

export default new FramesClient();